function base64urlencode(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export async function generatePkce() {
  const randomBytes = new Uint8Array(32);
  crypto.getRandomValues(randomBytes);
  const verifier = base64urlencode(randomBytes);

  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  const challenge = base64urlencode(digest);

  return { verifier, challenge };
}

export async function redirectToAuthorize({ apiBaseUrl, clientId, redirectUri }) {
  const { verifier, challenge } = await generatePkce();

  localStorage.setItem("pkce_code_verifier", verifier);
  // Stash the exact client_id/redirect_uri used to build this authorize
  // request, so the /callback token exchange can echo them back exactly -
  // using a different (e.g. stale config-default) client_id/redirect_uri to
  // exchange the code than the ones the SSO server issued it for causes a
  // guaranteed invalid_client/invalid_grant failure on every attempt.
  localStorage.setItem("pkce_client_id", clientId);
  localStorage.setItem("pkce_redirect_uri", redirectUri);

  const params = new URLSearchParams({
    response_type: "code",
    client_id: clientId,
    scope: "openid profile email",
    redirect_uri: redirectUri,
    code_challenge: challenge,
    code_challenge_method: "S256",
    state: crypto.randomUUID(),
    // Force the login page to show every time, even if the auth server
    // still has a live session cookie from a previous (possibly failed)
    // logout. Without this, a stale session silently re-issues a code.
    prompt: "login",
  });

  const queryString = params.toString().replace(/\+/g, "%20");
  window.location.href = `${apiBaseUrl}/oauth2/authorize?` + queryString;
}
